import React from "react";

const AUDIO_OPTIONS:string[]=["No audio", "British female", "American male", "Australian female", "Singaporean male", "British male", "American female"];
// const AUDIO_OPTIONS:string[]=["No audio", "British female", "American male"];

interface PropsType{
    audioChosen:number;
    selectAudio:Function;
}

export default class ContentVoiceOptions extends React.Component<PropsType>{

	constructor(props:PropsType){
		super(props);
	}

    render(){

		let myOptions=AUDIO_OPTIONS.map((option:string, optionIndex:number)=>{
			return <ContentVoiceOption key={optionIndex} optionIndex={optionIndex} optionName={option} audioChosen={this.props.audioChosen} selectAudio={this.props.selectAudio} />
		});
		return(
			<div className='teachers-contentset-audiooptions'>
				{myOptions}
			</div>
		)
	}
}

const ContentVoiceOption=function(props:{optionIndex:number, optionName:string, audioChosen:number, selectAudio:Function}){
	let isSelected=props.optionIndex===props.audioChosen;
	return(
		<div>
			<input className='teachers-content-checkbox' type="checkbox" checked={isSelected} onChange={()=>{props.selectAudio(props.optionIndex)}}></input>
			<span className='teachers-content-checkboxtext'>{props.optionName}</span>
		</div>
	)
}
